module.exports = __webpack_public_path__ + "media/nol.9def501c.mp4";